import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApplePay = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_12763_1848)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 15,
			x: .5,
			y: 2.5,
			fill: "white",
			stroke: "black",
			rx: 1.5
		}), /* @__PURE__ */ _jsx("path", {
			fill: "black",
			d: "M5.21875 8.22656C5.40625 8.01562 5.52344 7.73437 5.5 7.42969C5.24219 7.45312 4.9375 7.59375 4.75 7.80469C4.58594 7.99219 4.44531 8.29688 4.49219 8.57812C4.77344 8.60156 5.05469 8.4375 5.21875 8.22656ZM5.47656 8.625C5.64063 8.64844 6.10938 8.69531 6.39063 9.11719C6.36719 9.14062 5.85156 9.44531 5.85156 10.0781C5.875 10.8281 6.50781 11.0625 6.53125 11.0625C6.50781 11.0859 6.41406 11.4375 6.17969 11.7656C5.96875 12.0703 5.75781 12.375 5.42969 12.375C5.10156 12.3984 4.98438 12.1875 4.60938 12.1875C4.23438 12.1875 4.11719 12.375 3.78906 12.3984C3.46094 12.3984 3.22656 12.0703 3.01563 11.7656C2.59375 11.1328 2.26563 10.0312 2.6875 9.25781C2.92188 8.88281 3.29688 8.64844 3.71875 8.64844C4.04688 8.64844 4.32812 8.85938 4.53906 8.85938C4.72656 8.85938 5.07813 8.60156 5.47656 8.625ZM7.84375 7.78125L9.55469 7.78125C10.4453 7.78125 11.0547 8.39062 11.0547 9.28125C11.0547 10.1719 10.4219 10.7812 9.53125 10.7812L8.54688 10.7812V12.3516H7.84375V7.78125ZM8.54688 8.36719V10.1953L9.36719 10.1953C9.97656 10.1953 10.3281 9.86719 10.3281 9.28125C10.3281 8.69531 9.97656 8.36719 9.36719 8.36719H8.54688ZM12.3438 12.375C11.6875 12.375 11.2422 12 11.2188 11.3906C11.2188 10.8047 11.6641 10.4766 12.5078 10.4297L13.375 10.3828V10.125C13.375 9.75 13.1406 9.53906 12.6953 9.53906C12.3438 9.53906 12.0859 9.72656 12.0391 10.0078H11.4062C11.4062 9.42187 11.9688 9 12.7188 9C13.5391 9 14.0547 9.42187 14.0547 10.0781L14.0547 12.3516H13.3984V11.7891C13.2109 12.1641 12.7891 12.375 12.3438 12.375ZM12.5313 11.8359C13.0234 11.8359 13.375 11.5312 13.375 11.1094V10.8516L12.6016 10.8984C12.1563 10.9219 11.9219 11.0859 11.9219 11.3906C11.9219 11.6484 12.1563 11.8359 12.5313 11.8359ZM14.9453 13.5937C14.8984 13.5937 14.7109 13.5937 14.6641 13.5703V13.0312C14.7109 13.0312 14.8281 13.0312 14.875 13.0312C15.2031 13.0312 15.3672 12.9141 15.4844 12.5625L15.5547 12.3516L14.3359 9.02344L15.0859 9.02344L15.9297 11.7422L16.7734 9.02344H17.5L16.2344 12.5156C15.9531 13.3359 15.625 13.5937 14.9453 13.5937Z"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_12763_1848",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgApplePay);
export default ForwardRef;
